var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section--desc mt-5"},[_c('div',{staticClass:"subtitle--text"},[_vm._v(_vm._s(_vm.$t('addListing.description')))]),_c('hr'),_c('div',[(_vm.description !== null)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }